import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form/immutable';

import BasicForm from './BasicForm';
import * as constraints from '../../utils/constraints';

const AdministratorForm = ({ handleSubmit, submitting }) => (
  <form onSubmit={handleSubmit}>
    <BasicForm submitting={submitting} />
  </form>
);

const { func, bool } = PropTypes;

AdministratorForm.propTypes = {
  handleSubmit: func.isRequired,
  submitting: bool
};

export default reduxForm({
  form: 'signUp',
  validate: constraints.validations(constraints.user)
})(AdministratorForm);



// WEBPACK FOOTER //
// ./src/components/user/AdministratorForm.js